// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 708) return "chunks/708.js";
	// return url for filenames based on template
	return undefined;
};